export default __webpack_public_path__ + "static/media/after@3x.6192b5d9.jpg";